<div class="dialog-container">
  <h2 mat-dialog-title>Mudança de Plano de Pagamento</h2>

  <mat-dialog-content>
    <!-- Verificação Inicial de Elegibilidade -->
    <div *ngIf="!verificado" class="section">
      <h3>Verificar Elegibilidade</h3>
      <p class="description">
        Verifique se sua matrícula está elegível para mudança de plano.
      </p>
      <button
        mat-raised-button
        color="primary"
        (click)="verificarElegibilidade()"
        [disabled]="isLoading"
      >
        <span *ngIf="!isLoading">Verificar Elegibilidade</span>
        <mat-spinner
          *ngIf="isLoading"
          diameter="20"
          style="display: inline-block; margin-right: 10px"
        ></mat-spinner>
      </button>
    </div>

    <!-- Resultado da Verificação -->
    <div *ngIf="verificado && elegibilidade" class="section">
      <mat-card [ngClass]="elegibilidade.elegivel ? 'eligible' : 'ineligible'">
        <mat-card-header>
          <mat-card-title>
            {{ elegibilidade.elegivel ? "✓ Elegível" : "✗ Não Elegível" }}
          </mat-card-title>
        </mat-card-header>
        <mat-card-content>
          <div class="info-grid">
            <div class="info-item">
              <span class="label">Parcelas em Aberto:</span>
              <span class="value">{{ elegibilidade.parcelasEmAberto }}</span>
            </div>
            <div class="info-item">
              <span class="label">Parcelas Pagas:</span>
              <span class="value">{{ elegibilidade.parcelasPagas }}</span>
            </div>
            <div class="info-item">
              <span class="label">Parcelas Vencidas:</span>
              <span class="value">{{ elegibilidade.parcelasVencidas }}</span>
            </div>
            <div class="info-item">
              <span class="label">Saldo Devido:</span>
              <span class="value">
                {{ elegibilidade.saldoDevido | currency: "BRL" }}
              </span>
            </div>
          </div>
          <p class="message" [ngClass]="elegibilidade.elegivel ? 'success' : 'error'">
            {{ elegibilidade.mensagem }}
          </p>
        </mat-card-content>
      </mat-card>

      <!-- Formulário de Mudança de Plano -->
      <div *ngIf="elegibilidade.elegivel" class="form-section">
        <h3>Selecionar Novo Plano</h3>
        <form [formGroup]="form">
          <!-- Tipo de Pagamento -->
          <mat-form-field appearance="fill" class="full-width">
            <mat-label>Tipo de Pagamento</mat-label>
            <mat-select
              formControlName="tipoPagamentoNovo"
              (selectionChange)="onTipoPagamentoChange($event.value)">
              <mat-option value="">Selecione um tipo</mat-option>
              <mat-option *ngFor="let tipo of tiposPagamento" [value]="tipo.id">
                {{ tipo.label }}
              </mat-option>
            </mat-select>
            <mat-error *ngIf="form.get('tipoPagamentoNovo').hasError('required')">
              Tipo de pagamento é obrigatório
            </mat-error>
          </mat-form-field>

          <!-- Planos Disponíveis -->
          <mat-form-field appearance="fill" class="full-width" *ngIf="form.get('tipoPagamentoNovo').value">
            <mat-label>Novo Plano de Pagamento</mat-label>
            <mat-select formControlName="novoPlanoPagamentoId" [disabled]="sendingPlanos">
              <mat-option value="">
                <span *ngIf="sendingPlanos">Carregando planos...</span>
                <span *ngIf="!sendingPlanos && planosDisponiveis.length === 0">Nenhum plano disponível</span>
                <span *ngIf="!sendingPlanos && planosDisponiveis.length > 0">Selecione um plano</span>
              </mat-option>
              <mat-option *ngFor="let plano of planosDisponiveis" [value]="plano.id">
                {{ plano.quantidadeParcela }}x {{ plano.valorParcela | currency}}
              </mat-option>
            </mat-select>
            <mat-error *ngIf="form.get('novoPlanoPagamentoId').hasError('required')">
              Plano é obrigatório
            </mat-error>
          </mat-form-field>

          <!-- Campos TEF (PIX) -->
          <div *ngIf="form.get('tipoPagamentoNovo').value === 8" class="form-section">
            <h4>Dados da Transação TEF/PIX</h4>
            <mat-form-field appearance="fill" class="full-width">
              <mat-label>NSU (opcional)</mat-label>
              <input matInput formControlName="tefNsu" placeholder="NSU da transação" />
            </mat-form-field>

            <mat-form-field appearance="fill" class="full-width">
              <mat-label>Autorização (opcional)</mat-label>
              <input matInput formControlName="tefAutorizacao" placeholder="Código de autorização" />
            </mat-form-field>

            <mat-form-field appearance="fill" class="full-width">
              <mat-label>Valor (opcional)</mat-label>
              <input matInput formControlName="tefValor" type="number" placeholder="Valor da transação" />
            </mat-form-field>

            <mat-form-field appearance="fill" class="full-width">
              <mat-label>Parcelas (opcional)</mat-label>
              <input matInput formControlName="tefParcelas" type="number" placeholder="Número de parcelas" />
            </mat-form-field>
          </div>

          <!-- Observações -->
          <mat-form-field appearance="fill" class="full-width">
            <mat-label>Observações (opcional)</mat-label>
            <textarea
              matInput
              formControlName="observacao"
              rows="3"
              placeholder="Motivo ou observações sobre a mudança"
            ></textarea>
          </mat-form-field>
        </form>
      </div>
    </div>

    <!-- Mensagens de Erro -->
    <div *ngIf="error" class="error-message">
      <mat-icon>error_outline</mat-icon>
      <span>{{ elegibilidade?.mensagem || "Ocorreu um erro ao processar sua solicitação." }}</span>
    </div>
  </mat-dialog-content>

  <mat-dialog-actions align="end">
    <button mat-button (click)="onCancel()">Cancelar</button>
    <button mat-stroked-button color="primary" type="button"
            *ngIf="elegibilidade?.elegivel && form.valid"
            (click)="abrirMultiplosPagamentos()">
      <mat-icon>payments</mat-icon>
      Múltiplos Pagamentos
    </button>
    <button
      mat-raised-button
      color="primary"
      (click)="executarMudancaPlano()"
      [disabled]="!form.valid || !elegibilidade?.elegivel || sending"
    >
      <span *ngIf="!sending">Confirmar Mudança</span>
      <mat-spinner
        *ngIf="sending"
        diameter="20"
        style="display: inline-block; margin-right: 10px"
      ></mat-spinner>
    </button>
  </mat-dialog-actions>
</div>
